export default {
  action_types: [],
  autocomplete_data : [],
  autocomplete_selected : {},
  action_type:[],
  selected_action_type : {},
  action_type_status:[]
}
